import NavBar from "./NavBar";
import ChatPreview from "./ChatLibrary/ChatPreview";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { Link as ReactRouterLink } from "react-router-dom";
import FeatureBanner from "./FeatureBanner"
import { db } from "../firebase";
import {
    Link,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import NewChatCard from "./ChatLibrary/NewChatCard";
import { useRedirectToLogin } from "../lib/hooks";
import { useAccount } from "../lib/accountContext";


const ChatLibrary = () => {
    const account = useAccount();

    const [featureChats, setFeaturedChats] = useState([]);
    const [userChats, setUserChats] = useState([]); // State to store user chats

    useRedirectToLogin();

    useEffect(() => {
        const getFeaturedChats = async () => {

            const featuredChatsPromise = getDocs(collection(db, "featuredChats"));
            const userChatsPromise = getDoc(doc(db, "users", account.user.uid));

            const [featuredChatsSnapshot, userDoc] = await Promise.all([
                featuredChatsPromise,
                userChatsPromise,
            ]);

            const data = featuredChatsSnapshot.docs.map((doc) => ({ path: doc.id, ...doc.data() }));

            // Filter the data to include only documents with a "z" field
            const zIndexData = data.filter((chat) => chat.z !== undefined);

            // Sort the zIndexData by the "z" value in descending order
            const sortedZIndexData = zIndexData.sort((a, b) => b.z - a.z);

            // Filter the data to exclude documents with a "z" field
            const noZIndexData = data.filter((chat) => chat.z === undefined);

            // Concatenate the sortedZIndexData and noZIndexData arrays
            const finalData = sortedZIndexData.concat(noZIndexData);

            setFeaturedChats(finalData);

            if (userDoc.exists) {
                const userChatsData = userDoc.data().chats || [];
                setUserChats(userChatsData);
            }
        }
        getFeaturedChats();

    }, [account.user]);

    return (
        <>
            <NavBar />
            <div className="w-[80%] m-auto mt-10">
                <FeatureBanner featureName="ChatPDF" featureDescription="Upload a PDF and Robin will answer and reference the PDF. Saving a PowerPoint as a PDF works great!" />
            </div>
            {
                account.isSubscribed && (
                    <section className="w-full">
                        <div className="mx-10">
                            <h1 className="m-10 mx-10 text-2xl font-semibold text-heading md:text-6xl">
                                Your Chats
                            </h1>
                            <div className="flex w-full flex-wrap justify-center lg:justify-start">
                                <NewChatCard />
                                {
                                    userChats.map((chat, index) => (
                                        <Link key={index} as={ReactRouterLink} to={chat.path} style={{ textDecoration: "none" }}>
                                            <ChatPreview key={index} title={chat.file_name} image_url={chat.image_url} />
                                        </Link>
                                    ))
                                }
                            </div>
                        </div>
                    </section>
                )
            }
            <section className="w-full">
                <div className="mx-10">
                    <h1 className="m-10 text-2xl font-semibold text-heading md:text-6xl">
                        Featured Chats
                    </h1>
                    <div className="flex w-full flex-wrap justify-center md:justify-start">
                        {featureChats.map((chat, index) => (
                            <Link as={ReactRouterLink} to={chat.path} style={{ textDecoration: "none" }}>
                                <ChatPreview key={index} title={chat.title} description={chat.description} image_url={chat.image_url} />
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default ChatLibrary;
